import React, { useMemo, useState } from "react";
import { FaRegSave } from "react-icons/fa";
import "./CaseTasks.css";

const label = (t) => (t.department ? `${t.name} (${t.department})` : t.name);

// tasks = [{ id, name, department }]  ->  drag them into Case Start / Case End columns
// onSave({ start: [ids], end: [ids] }) - connect your API here
const CaseTasks = ({ tasks = [], onSave }) => {
  const [start, setStart] = useState([]);
  const [end, setEnd] = useState([]);
  const [over, setOver] = useState(null);

  const byId = (id) => tasks.find((t) => t.id === id);
  const available = useMemo(() => {
    const used = new Set([...start, ...end]);
    // tasks without a department first, like the reference screenshot
    return tasks.filter((t) => !used.has(t.id)).sort((a, b) => (a.department ? 1 : 0) - (b.department ? 1 : 0));
  }, [tasks, start, end]);

  const move = (id, zone) => {
    const s = start.filter((x) => x !== id);
    const e = end.filter((x) => x !== id);
    if (zone === "start") s.push(id);
    if (zone === "end") e.push(id);
    setStart(s);
    setEnd(e);
  };

  const onDrop = (zone) => (ev) => {
    ev.preventDefault();
    setOver(null);
    const t = tasks.find((x) => String(x.id) === ev.dataTransfer.getData("text/plain"));
    if (t) move(t.id, zone);
  };

  const item = (t, removable) => (
    <div
      key={t.id}
      className="ct-item"
      draggable
      onDragStart={(ev) => ev.dataTransfer.setData("text/plain", String(t.id))}
    >
      <span>{label(t)}</span>
      {removable && <button type="button" onClick={() => move(t.id, "avail")} title="Remove">×</button>}
    </div>
  );

  const column = (title, zone, ids) => (
    <div className="ct-col">
      <h4 className="ct-head">{title}</h4>
      <div
        className={"ct-box" + (over === zone ? " ct-over" : "")}
        onDragOver={(ev) => { ev.preventDefault(); setOver(zone); }}
        onDragLeave={() => setOver(null)}
        onDrop={onDrop(zone)}
      >
        <div className="ct-bar" />
        {zone === "avail" ? (
          <div className="ct-list">{available.map((t) => item(t, false))}</div>
        ) : (
          <>
            <div className="ct-strip" />
            <div className="ct-body">
              {ids.length === 0 ? (
                <div className="ct-drop">Drag &amp; drop tasks here</div>
              ) : (
                ids.map((id) => byId(id)).filter(Boolean).map((t) => item(t, true))
              )}
            </div>
          </>
        )}
        <div className="ct-bar ct-bottom" />
      </div>
    </div>
  );

  return (
    <div className="ct-page">
      <div className="ct-cols">
        {column("Case Start Tasks", "start", start)}
        {column("Available Tasks", "avail", [])}
        {column("Case End Tasks", "end", end)}
      </div>
      <div className="ct-actions">
        <button type="button" className="ct-save" onClick={() => onSave && onSave({ start, end })}>
          <FaRegSave /> Save
        </button>
      </div>
    </div>
  );
};

export default CaseTasks;